var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 0L61.0026 8.94369L75 6.69759L80.0537 19.9463L93.3024 25L91.0563 38.9974L100 50L91.0563 61.0026L93.3024 75L80.0537 80.0537L75 93.3024L61.0026 91.0563L50 100L38.9974 91.0563L25 93.3024L19.9463 80.0537L6.69759 75L8.94369 61.0026L0 50L8.94369 38.9974L6.69759 25L19.9463 19.9463L25 6.69759L38.9974 8.94369L50 0ZM50 32.1777L55.1595 44.7835L68.7419 45.7926L58.3496 54.598L61.5885 67.8304L50.0081 60.6608L38.4277 67.8304L41.6667 54.598L31.2581 45.7926L44.8405 44.7835L50 32.1777ZM50 21.7367C65.6087 21.7367 78.2634 34.3913 78.2634 50C78.2634 65.6087 65.6087 78.2634 50 78.2634C34.3913 78.2634 21.7367 65.6087 21.7367 50C21.7367 34.3913 34.3913 21.7367 50 21.7367Z",
    fill: "url(#paint0_linear_13175_7218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13175_7218",
    x1: 8.903,
    y1: 7.32422,
    x2: 70.3451,
    y2: 95.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.585263,
    stopColor: "#005EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2987D1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremier);
export default __webpack_public_path__ + "static/media/premier.633822540f049f2123663bee66861a3c.svg";
export { ForwardRef as ReactComponent };